import React, { useEffect, useState } from 'react';
import PriceComparatorPageBasic from './PriceComparatorPageBasic';
import PriceComparatorPro from './PriceComparatorPro';
import './PriceComparatorPro.css';
import { useRemainingPacks } from '../../hooks/useRemainingPacks';
import CircularLoading from '../../shared/CircularLoading/CircularLoading';

const PriceComparatorPage: React.FC = () => {
	const [showPriceComparatorPro, setShowPriceComparatorPro] = useState(true);

	const {
		data: remainingPacks,
		loading: loadingCalcs,
		error: errorCalcs,
		refetch: refetchRemainingCalcs,
	} = useRemainingPacks(process.env.REACT_APP_PRICE_COMPARATOR_ID || '354');

	// console.log(remainingPacks);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);

	if (loadingCalcs) {
		return <CircularLoading />;
	}

	return <>{remainingPacks?.results && remainingPacks.results.length > 0 ? <PriceComparatorPro /> : <PriceComparatorPageBasic />}</>;
};

export default PriceComparatorPage;
